// utils
import { addAllValue } from 'src/utils/DataTrees'
import { addAllValue as addAllValueV5 } from 'src/utils/v5/DataTrees'

export const MEDICAL_DEVICE_ORDERING_DEFAULT_SORT = {
  sortedColumn: 'status',
  sortedColumnOrder: 'ascend'
}

export const MEDICAL_DEVICE_ORDERING_STATUSES = new Map([
  [
    1,
    {
      className: 'status-medical-device-pending',
      key: 'pending',
      title: 'Pending',
      label: 'Pending',
      value: 1
    }
  ],
  [
    2,
    {
      className: 'status-medical-device-in-progress',
      key: 'inProgress',
      title: 'In progress',
      label: 'In progress',
      value: 2
    }
  ],
  [
    3,
    {
      className: 'status-medical-device-in-progress',
      key: 'Shipped',
      title: 'Shipped',
      label: 'Shipped',
      value: 3
    }
  ],
  [
    4,
    {
      className: 'status-delivered',
      key: 'delivered',
      title: 'Delivered',
      label: 'Delivered',
      value: 4
    }
  ],
  [
    5,
    {
      className: 'status-canceled',
      key: 'canceled',
      title: 'Canceled',
      label: 'Canceled',
      value: 5
    }
  ],
  [
    6,
    {
      className: 'status-canceled',
      key: 'Returned',
      title: 'Returned',
      label: 'Returned',
      value: 6
    }
  ],
  [
    7,
    {
      className: 'status-canceled',
      key: 'Lost',
      title: 'Lost',
      label: 'Lost',
      value: 7
    }
  ]
])

export const MEDICAL_DEVICE_ORDERING_STATUSES_DROPDOWN = Array.from(
  MEDICAL_DEVICE_ORDERING_STATUSES
).map(([_, item]) => {
  const updItem = { ...item }

  delete updItem.className

  return updItem
})

export const MEDICAL_DEVICE_ORDERING_STATUSES_WITH_ALL = addAllValue(
  MEDICAL_DEVICE_ORDERING_STATUSES_DROPDOWN
)

export const MEDICAL_DEVICE_ORDERING_STATUSES_WITH_ALL_V5 = addAllValueV5({
  list: MEDICAL_DEVICE_ORDERING_STATUSES_DROPDOWN
})

export const MEDICAL_DEVICE_ORDERING_SHIP_BY = new Map([
  [
    1,
    {
      key: 'byOffice',
      title: 'By Office',
      label: 'By Office',
      value: 1
    }
  ],
  [
    2,
    {
      key: 'byShipbob',
      title: 'By ShipBob',
      label: 'By ShipBob',
      value: 2
    }
  ]
])

export const MEDICAL_DEVICE_ORDERING_SHIP_BY_DROPDOWN = Array.from(
  MEDICAL_DEVICE_ORDERING_SHIP_BY
).map(([_, item]) => item)

export const MEDICAL_DEVICE_ORDERING_SHIP_BY_WITH_ALL = addAllValue(
  MEDICAL_DEVICE_ORDERING_SHIP_BY_DROPDOWN
)

export const MEDICAL_DEVICE_ORDERING_SHIP_BY_WITH_ALL_V5 = addAllValueV5({
  list: MEDICAL_DEVICE_ORDERING_SHIP_BY_DROPDOWN,
  convertList: true
})
